/**
 * Digital products mapping for icon files
 * 
 * This file maps different variations of digital product names to their corresponding icon filenames.
 * 
 * Format:
 * 'product name variation': 'filename.gif'
 */

const digitalProductsMapping = {
  // 3D Cube
  '3d cube': '3D_Cube-V1.gif',
  'cube': '3D_Cube-V1.gif',
  '3d': '3D_Cube-V1.gif',
  
  // Speech Bubble
  'speech bubble': 'Speech_bubble-V1.gif',
  'speechbubble': 'Speech_bubble-V1.gif',
  'chat bubble': 'Speech_bubble-V1.gif',
  
  // Skin
  'skin': 'Skin-V1.gif',
  
  // Sectie Takeover
  'sectie takeover': 'Sectie_takeover-V1.gif',
  'sectietakeover': 'Sectie_takeover-V1.gif',
  'section takeover': 'Sectie_takeover-V1.gif',
  
  // Scoreboard
  'scoreboard': 'Scoreboard.gif',
  'score board': 'Scoreboard.gif',
  
  // Native Ad
  'native ad': 'Native_ad.gif',
  'Native Ad': 'Native_ad.gif',
  'nativead': 'Native_ad.gif',
  'NativeAd': 'Native_ad.gif',
  
  // Fluid Ad
  'fluid ad': 'Fluid_Ad-V1.gif',
  'Fluid Ad': 'Fluid_Ad-V1.gif',
  'fluidad': 'Fluid_Ad-V1.gif',
  'FluidAd': 'Fluid_Ad-V1.gif',
  
  // Nieuwsbrief
  'nieuwsbrief': 'Nieuwsbrief.gif',
  'Nieuwsbrief': 'Nieuwsbrief.gif',
  'newsletter': 'Nieuwsbrief.gif',
  'Newsletter': 'Nieuwsbrief.gif',
  
  // Mobile Portrait
  'mobile portrait': 'Mobile_portrait.gif',
  'Mobile Portrait': 'Mobile_portrait.gif',
  'mobileportrait': 'Mobile_portrait.gif',
  'MobilePortrait': 'Mobile_portrait.gif',
  
  // Mobile Halfpage Ad
  'mobile halfpage ad': 'Mobile_halpage_ad.gif',
  'Mobile Halfpage Ad': 'Mobile_halpage_ad.gif',
  'mobile halfpage': 'Mobile_halpage_ad.gif',
  'Mobile Halfpage': 'Mobile_halpage_ad.gif',
  'mobilehalfpagead': 'Mobile_halpage_ad.gif',
  'MobileHalfpageAd': 'Mobile_halpage_ad.gif',
  
  // Interscroller
  'interscroller': 'Interscroller-V1.gif',
  'Interscroller': 'Interscroller-V1.gif',
  
  // Dagbladen
  'dagbladen': 'Dagbladen.gif',
  'newspapers': 'Dagbladen.gif',
  
  // Highlight AD
  'highlight ad': 'Highlight_AD-v2.gif',
  'highlightad': 'Highlight_AD-v2.gif',
  
  // Brandstory Longread
  'brandstory longread': 'Brandstory_longread.gif',
  'brandstorylongread': 'Brandstory_longread.gif',
  'brand story longread': 'Brandstory_longread.gif',
  
  // IAB Display/Rectangle
  'iab display': 'IAB_Display-V1.gif',
  'IAB Display': 'IAB_Display-V1.gif',
  'iabdisplay': 'IAB_Display-V1.gif',
  'IABDisplay': 'IAB_Display-V1.gif',
  'Rectangle': 'IAB_Display-V1.gif',
  'rectangle': 'IAB_Display-V1.gif',
  'IAB Rectangle': 'IAB_Display-V1.gif',
  'IAB rectangle': 'IAB_Display-V1.gif',
  
  // Elastic Social
  'elastic social': 'Elestic_social-V1.gif',
  'elasticsocial': 'Elestic_social-V1.gif',
  
  // In-article YouTube Video
  'in-article youtube video': 'In_article_Youtube_video.gif',
  'in article youtube video': 'In_article_Youtube_video.gif',
  'youtube video': 'In_article_Youtube_video.gif',
  
  // In-article Native Video
  'in-article native video': 'In_article_Native_video.gif',
  'in article native video': 'In_article_Native_video.gif',
  'native video': 'In_article_Native_video.gif',
  
  // Instream Video
  'instream video': 'Instream_video.gif',
  'instreamvideo': 'Instream_video.gif',
  
  // In-article Video
  'in-article video': 'In_article_video.gif',
  'in article video': 'In_article_video.gif',
};

/**
 * Get the correct icon filename for a digital product
 * @param {string} productName - The digital product name to look up
 * @returns {string} The correct icon filename or null if not found in mapping
 */
export const getDigitalProductIconFilename = (productName) => {
  if (!productName) return null;
  
  // First check exact match (preserve original capitalization)
  if (digitalProductsMapping[productName]) {
    return digitalProductsMapping[productName];
  }
  
  // Convert to lowercase for case-insensitive matching
  const normalizedName = productName.toLowerCase().trim();
  
  // Check if we have a direct mapping using lowercase
  if (digitalProductsMapping[normalizedName]) {
    return digitalProductsMapping[normalizedName];
  }
  
  // Try without special characters
  const cleanName = normalizedName.replace(/[^a-z0-9\s]/g, '').trim();
  if (digitalProductsMapping[cleanName]) {
    return digitalProductsMapping[cleanName];
  }
  
  // Try without spaces
  const noSpaces = cleanName.replace(/\s+/g, '');
  if (digitalProductsMapping[noSpaces]) {
    return digitalProductsMapping[noSpaces];
  }
  
  // Try checking for partial matches in the product name
  for (const key in digitalProductsMapping) {
    // Skip keys that are longer than the product name
    if (key.length > normalizedName.length) continue;
    
    // Check if the product name contains the key
    if (normalizedName.includes(key.toLowerCase())) {
      return digitalProductsMapping[key];
    }
  }
  
  // No mapping found
  console.log(`No digital product mapping found for: ${productName}`);
  return null;
};

export default digitalProductsMapping; 